import React from "react";
import DashboardMap from "@components/operatorLobby/DashboardMap";
import './VehicleDashboard.css';
import AlertMessageDisplay from "@components/VehicleDashboard/alertMessage/AlertMessageDisplay.js"
import VehicleStateDisplayArray from "@components/VehicleDashboard/vehicleState/VehicleStateDisplayArray.js"
import DashboardLightArray from "@components/VehicleDashboard/dashboardLight/DashboardLightArray.js"
import RotationDisplayArray from "@components/VehicleDashboard/rotationDisplay/RotationDisplayArray.js"
import VehicleSpeedDisplayArray from "@components/VehicleDashboard/vehicleSpeedDisplay/VehicleSpeedDisplayArray.js"

  export default function VehicleDashboard({ listOfAvailableVehicles, vehicle, alerts, telemetryData, devices }) {

  const dashboardMap = (
    <DashboardMap vehicles={listOfAvailableVehicles} selectedVehicle={vehicle}/>
  );

  let content = (
    <>
      <div className={`container-fluid ${'autosnow'}`}>
          <div className="row">
            <div className={`col-md-6 ${'quarter'}`}>
              <div className="map-container">
                {dashboardMap}
              </div>
            </div>
            <div className={`col-md-6 ${'quarter'}`}>
              <div className="row">
                <div className="col-md-4">
                  <VehicleStateDisplayArray vehicle={vehicle}/>
                </div>
                <div className={`col-md-8`}>  
                  <AlertMessageDisplay alerts={alerts}/>
                  <VehicleSpeedDisplayArray linearSpeed={telemetryData.linearSpeed} 
                                            linearSpeedLimit={telemetryData.linearSpeedLimit} 
                                            angularSpeed={telemetryData.angularSpeed}  
                                            angularSpeedLimit={telemetryData.angularSpeedLimit} 
                                            rpm={telemetryData.rpm} 
                                            fuel={telemetryData.fuelPercentage}/>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className={`col-md-6 ${'quarter'}`}>
              <div className="row">
                  <DashboardLightArray data={telemetryData} devices={devices}/>
              </div>
            </div>
            <div className={`col-md-6 ${'quarter'}`}>
              <RotationDisplayArray roll={telemetryData.roll} pitch={telemetryData.pitch}/>
            </div>
          </div>
      </div>
    </>
  );

  return content;
}